export default __webpack_public_path__ + "static/media/Leg_right.407e2fa9.svg";